import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public NoOfLoaderCount: any = 0;
  public isLoaderOn = new BehaviorSubject<boolean>(false);

  loadSpinner(status: boolean) {
    if (status) {
      this.NoOfLoaderCount++;
    } else {
      this.NoOfLoaderCount--;
    }

    if (this.NoOfLoaderCount == 1) {
      this.isLoaderOn.next(true);
    } else if (this.NoOfLoaderCount <= 0) {
      this.NoOfLoaderCount = 0;
      this.isLoaderOn.next(false);
    }
  }
}
